// ── Scoring ──────────────────────────────────────────────
export function scoreItem(valueIndex, isInverse, scale) {
  if (valueIndex == null || valueIndex < 0) return null;
  return isInverse ? scale - valueIndex : valueIndex;
}

// ── Frequency options ────────────────────────────────────
export const FREQ_DIET = [
  "Nunca",
  "1-2 veces/semana",
  "3-4 veces/semana",
  "Diario (1 vez)",
  "Diario (2+ veces)",
];

export const FREQ_BEHAVIOR = ["Nunca", "A veces", "Frecuentemente", "Siempre"];

// ── Food items (10) ──────────────────────────────────────
export const FOOD_ITEMS = [
  { id: "frutas", label: "Frutas frescas", inverse: false },
  { id: "verduras", label: "Verduras frescas o cocidas", inverse: false },
  { id: "integrales", label: "Cereales integrales (arroz integral, avena, pan integral)", inverse: false },
  { id: "refinados", label: "Productos refinados (pan blanco, arroz blanco, harinas)", inverse: true },
  { id: "legumbres", label: "Legumbres (frijoles, lentejas, garbanzos)", inverse: false },
  { id: "carnes", label: "Carnes magras o pescado", inverse: false },
  { id: "lacteos", label: "Lácteos o alternativas vegetales", inverse: false },
  { id: "grasas", label: "Grasas saludables (aguacate, nueces, aceite de oliva)", inverse: false },
  { id: "frituras", label: "Frituras o comida rápida", inverse: true },
  { id: "azucaradas", label: "Bebidas azucaradas (gaseosas, jugos de caja, energizantes)", inverse: true },
];

// ── Behavior items (5) ───────────────────────────────────
export const BEHAVIOR_ITEMS = [
  { id: "saltarse", label: "¿Sueles saltarte alguna comida principal (desayuno, almuerzo o cena)?", inverse: true },
  { id: "comida_rapida", label: "¿Sueles pedir comida rápida o comer fuera de casa?", inverse: true },
  { id: "planear", label: "¿Planeas tus comidas con anticipación?", inverse: false },
  { id: "agua", label: "¿Tomas agua de forma regular durante el día?", inverse: false },
  { id: "azucar", label: "¿Añades azúcar o endulzante a tus bebidas?", inverse: true },
];

// ── Hydration ────────────────────────────────────────────
export const HYDRATION_OPTIONS = [
  { label: "Menos de 4 (menos de 1 litro)", value: "lt4", category: "Insuficiente", color: "#C0453A", key: "insufficient" },
  { label: "4 a 6 (1 a 1.5 litros)", value: "4-6", category: "Bajo", color: "#F9A01B", key: "low" },
  { label: "7 a 8 (1.75 a 2 litros)", value: "7-8", category: "Adecuado", color: "#157346", key: "adequate" },
  { label: "Más de 8 (más de 2 litros)", value: "gt8", category: "Óptimo", color: "#157346", key: "optimal" },
];

// ── Motivation options ───────────────────────────────────
export const MOTIVATION_GOALS = [
  "Bajar de peso",
  "Controlar azúcar o colesterol",
  "Mejorar energía o digestión",
  "Ganar masa muscular",
  "Comer más saludable en general",
];

export const MOTIVATION_LEVELS = [
  "Nada motivado/a",
  "Poco",
  "Neutral",
  "Motivado/a",
  "Muy motivado/a",
];

export const RESTRICTION_OPTIONS = [
  "Vegetariano/a",
  "Vegano/a",
  "Sin gluten",
  "Sin lácteos",
  "Alergias",
  "Por religión o cultura (kosher/halal)",
  "Ninguna",
  "Otra",
];

// ── Classification helpers ───────────────────────────────
export function classifyDiet(score) {
  if (score <= 15) return { label: "Dieta deficiente", color: "#C0453A", key: "poor" };
  if (score <= 25) return { label: "Dieta mejorable", color: "#F9A01B", key: "fair" };
  if (score <= 33) return { label: "Dieta buena", color: "#157346", key: "good" };
  return { label: "Dieta excelente", color: "#157346", key: "excellent" };
}

export function classifyBehavior(score) {
  if (score <= 5) return { label: "Conductas de riesgo", color: "#C0453A", key: "risk" };
  if (score <= 9) return { label: "Conductas regulares", color: "#F9A01B", key: "fair" };
  if (score <= 12) return { label: "Conductas saludables", color: "#157346", key: "good" };
  return { label: "Conductas óptimas", color: "#157346", key: "optimal" };
}

export function getHydrationCategory(value) {
  return HYDRATION_OPTIONS.find((o) => o.value === value) || null;
}
